import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	name: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.service-desk-information.name',
		defaultMessage: 'Portal name',
		description: 'Change name of the project in customer portal settings',
	},
	introText: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.service-desk-information.intro-text',
		defaultMessage: 'Introduction text',
		description: 'Change introduction text of the project in customer portal settings',
	},
	save: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.service-desk-information.save',
		defaultMessage: 'Save',
		description: 'Save name and introduction Text in customer portal settings',
	},
	errorTooBig: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.service-desk-information.error-too-big',
		defaultMessage: 'This field must not exceed 2048 characters.',
		description: 'Error shown if the inputted text is too long',
	},
	errorFailed: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.service-desk-information.error-failed',
		defaultMessage: "We couldn't submit your form. Please try again.",
		description: 'Error shown if submitting fails',
	},
});
